/* global moment */
(function ($) {
    'use strict';
    $.widget("fd.control_datepicker", {
        options: {
            parentid: null,
            callback: function () { },
            mindate: null,
            maxdate: null,
            format: 'm/d/yy',
            formatsubmit: 'yyyy-mm-dd',
            formatmoment: 'M/D/YY',
            monthpicker: false,
            editable: true,
            showclearbutton: true,
            allownull: false,
            disabledays: []    // Array of days of the week, numbered 1 - 7.
        },
        _create: function () {
            var that = this;
            if (!this.options.parentid) {
                this.options.parentid = this.element.closest('[data-fd-parentid]').data('fd-parentid');
            }
            const datepickerOptions = {
                disable: this.options.disabledays,
                format: this.options.format,
                formatSubmit: this.options.formatsubmit,
                editable: this.options.editable,
                onSet: function (context) {
                    that._handleSubmit(this, context);
                }
            };

            // pickadate plugin expects a text for clear button or false to hide it
            datepickerOptions.clear = this.options.showclearbutton ? 'Clear' : false;

            if (this.options.mindate) {
                datepickerOptions.min = new Date(this.options.mindate);
            }
            if (this.options.maxdate) {
                datepickerOptions.max = new Date(this.options.maxdate);
            }
            if (this.options.monthpicker) {
                datepickerOptions.selectYears = true;
                datepickerOptions.selectMonths = true;
                datepickerOptions.onOpen = function () {
                    that._setMonthPickerUI();
                };
                datepickerOptions.onSet = function (e) {
                    if (e.highlight) {
                        var h = e.highlight instanceof Array ? e.highlight : [e.highlight.year, e.highlight.month, 1];
                        that.lastHighlightedDate = h;
                        that._setMonthPickerUI();
                    }
                };
            }

            this._datepickerInstance = this.element.pickadate(datepickerOptions);
            if (this.options.editable) {
                this._datepickerInstance.off('click focus');
            }
            this.element[0].fdReset = this._fdReset.bind(this);
            this.element[0].fdSetValue = this._fdSetValue.bind(this);
            this._setEvents();
        },
        _setEvents: function () {
            const element = this.element;
            const momentFormat = this.options.formatmoment;
            var $iconContainer = this.element.parent().find(".form-control-feedback");
            if ($iconContainer.length === 1) {
                var picker = element.pickadate('picker');
                $iconContainer.click(function () {
                    let date = new Date();
                    const inputDate = element.val();

                    if (moment(inputDate, momentFormat, true).isValid()) {
                        date = moment(inputDate, momentFormat, true).toDate();
                    }

                    if (!picker.get('open')) {
                        picker.set('select', date);
                        picker.open();
                    }
                });
            }

            const $validator = this.element.parent().find(".pickadate-validator");

            if (this.options.editable) {
                const momentFormat = this.options.formatmoment;
                const allownull = this.options.allownull;
                element.on('change',
                    function (event) {
                        const value = $(event.target).val();
                        const validDate = value && (
                            moment(value, momentFormat, true).isValid());
                        if (validDate || (!value && allownull)) {
                            $validator.hide();
                        } else {
                            $validator.show();
                            $validator.html("Invalid date. Valid format is m/d/yy");
                        }
                    });

                $("form").on("submit",
                    function (event) {
                        const value = $(element).val();
                        if (!value && allownull) {
                            return true;
                        }
                        const validDate = value && (
                            moment(value, momentFormat, true).isValid());
                        if (validDate || (!value && allownull)) {
                            return true;
                        }

                        event.preventDefault();
                        return false;
                    });
            }

        },
        _setMonthPickerUI: function () {
            var that = this;
            var $picker = this.element.parent()
                .find(".picker");

            if (!$picker.hasClass('month-only-picker')) {
                $picker.addClass('month-only-picker');
            }

            var $chooseButton = $picker.find(".picker__button--choose-month");
            if ($chooseButton.length === 0) {
                $chooseButton = $('<button class="picker__button picker__button--choose-month" type="button">Choose</button>');
            }

            var $yearSelect = $picker.find(".picker__select--year");
            var $monthSelect = $picker.find(".picker__select--month");

            $picker.find(".picker__nav--next")
                .off('click')
                .on('click', function () {
                    var year = parseInt($yearSelect.val());
                    var month = parseInt($monthSelect.val());
                    if (month === 11) {
                        year += 1;
                        month = -1;
                    }
                    that.lastHighlightedDate = [year, (month + 1), 1];
                });

            $picker.find(".picker__nav--prev")
                .off('click')
                .on('click', function () {
                    var year = parseInt($yearSelect.val());
                    var month = parseInt($monthSelect.val());
                    if (month === 0) {
                        year -= 1;
                        month = 1;
                    }
                    that.lastHighlightedDate = [year, (month - 1), 1];
                });

            var $pickerFooter = $picker.find(".picker__footer");
            $pickerFooter.append($chooseButton);
            $chooseButton.click(function () {
                var picker = that.element.pickadate('picker');
                if (that.lastHighlightedDate) {
                    that.lastHighlightedDate[2] = 1;
                    picker.set('select', that.lastHighlightedDate, { format: that.options.format });
                }
                picker.close();
            });
        },
        _fdSetValue: function (value) {
            this.element.val(value);
            this._fdReset();
        },
        _fdReset: function () {
            let val = this.element.val();
            this.element.pickadate('picker').set('select', val, { format: this.options.format });
        },
        _handleSubmit: function (datepicker, context) {
            var objContext = context.highlight || context.select;  // gets highlighted date during clicking 'next' and 'previous' arrows 
            var date = objContext?.obj || new Date(context.select); // fixes a bug when a date is picked using 'enter' key in keyboard
            this.options.callback.call(this, { parentid: this.options.parentid, value: moment(date).format(this.options.formatmoment) }, datepicker);
        },
        _datepickerInstance: null,
        _setOption: function (key, value) {
            this.options[key] = value;
        }
    });
}(jQuery));